export enum ProjectColumn {
    ORDER_NUMBER = 'orderNumber',
    STATUS = 'status',
    DUE_DATE = 'dueDate',
    SEARCHER = 'assignedToUser',
    SEARCH_TYPE = 'searchType',
    COUNTY = 'county',
    STATE = 'state',
    ADDRESS = 'address'
}

export const getProjectColumnHeader = (headerLabel: string): ProjectColumn | undefined => {
    switch (headerLabel) {
        case 'Order Number':
            return ProjectColumn.ORDER_NUMBER;
        case 'Status':
            return ProjectColumn.STATUS;
        case 'Due Date':
            return ProjectColumn.DUE_DATE;
        case 'Searcher':
            return ProjectColumn.SEARCHER;
        case 'Search Type':
            return ProjectColumn.SEARCH_TYPE;
        case 'County':
            return ProjectColumn.COUNTY;
        case 'State':
            return ProjectColumn.STATE;
        case 'Address':
            return ProjectColumn.ADDRESS;
        default:
            return undefined;
    }
}
